import React, { useState } from 'react';
import Button from '../components/ui/Button';
import emailjs from '@emailjs/browser';

const Contato: React.FC = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    empresa: '',
    mensagem: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const [sending, setSending] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceId || !templateId || !publicKey) {
      alert('Configuração de email ausente. Defina REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID e REACT_APP_EMAILJS_PUBLIC_KEY.');
      return;
    }

    try {
      setSending(true);
      const combinedMessage = `Nome: ${formData.nome}\nE-mail: ${formData.email}\nTelefone: ${formData.telefone || '-'}\nEmpresa: ${formData.empresa || '-'}\n\nMensagem:\n${formData.mensagem}`;
      const combinedMessageHtml = combinedMessage.replace(/\n/g, '<br/>');
      await emailjs.send(
        serviceId,
        templateId,
        {
          to_email: 'contato@consultoria.siqueiradigital.com.br',
          from_name: formData.nome,
          from_email: formData.email,
          phone: formData.telefone,
          company: formData.empresa,
          message: combinedMessage,
          message_html: combinedMessageHtml,
        },
        {
          publicKey,
        }
      );
      alert('Mensagem enviada com sucesso! Em breve entraremos em contato.');
      setFormData({
        nome: '',
        email: '',
        telefone: '',
        empresa: '',
        mensagem: ''
      });
    } catch (err) {
      console.error('Erro ao enviar email:', err);
      alert('Não foi possível enviar a mensagem agora. Tente novamente mais tarde.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Entre em Contato</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Estamos prontos para ajudar sua empresa a alcançar a excelência em gestão da qualidade
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl font-bold mb-6">Envie-nos uma mensagem</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="nome" className="block text-gray-700 mb-2">Nome completo</label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-gray-700 mb-2">E-mail</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="telefone" className="block text-gray-700 mb-2">Telefone</label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                />
              </div>
              
              <div>
                <label htmlFor="empresa" className="block text-gray-700 mb-2">Empresa</label>
                <input
                  type="text"
                  id="empresa"
                  name="empresa"
                  value={formData.empresa}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                />
              </div>
              
              <div>
                <label htmlFor="mensagem" className="block text-gray-700 mb-2">Mensagem</label>
                <textarea
                  id="mensagem"
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleChange}
                  rows={5}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                  required
                ></textarea>
              </div>
              
              <div>
                <Button type="submit" variant="primary" size="lg" disabled={sending}>
                  {sending ? 'Enviando...' : 'Enviar mensagem'}
                </Button>
              </div>
            </form>
          </div>
          
          <div>
            <h2 className="text-2xl font-bold mb-6">Informações de contato</h2>
            <div className="bg-gray-50 p-6 rounded-lg mb-8">
              <div className="mb-6">
                <h3 className="font-bold text-lg mb-2">Endereço</h3>
                <p className="text-gray-600">
                  Mogi das Cruzes, São Paulo - SP<br />                  
                </p>
              </div>
              
              <div className="mb-6">
                <h3 className="font-bold text-lg mb-2">Telefone</h3>
                <p className="text-gray-600">(11) 9 9666-6027</p>
              </div>
              
              <div>
                <h3 className="font-bold text-lg mb-2">E-mail</h3>
                <p className="text-gray-600">contato@aristia.com.br</p>
              </div>
            </div>
            
            <h2 className="text-2xl font-bold mb-4">Horário de atendimento</h2>
            <p className="text-gray-600 mb-2">Segunda a Sexta: 9h às 18h</p>
            <p className="text-gray-600">Sábados e Domingos: Fechado</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contato;